import { Input } from '@angular/core';

export class IconBase {
  @Input() size = 32;
}
